module.exports = __webpack_public_path__ + "static/img/sjfw-hd.922b0c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/index/img/sjfw-hd.png
// module id = Gr6H
// module chunks = 1